import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import "../../Styles/UserLogin.less";
import { Button, Checkbox, Form, Input, Layout, message } from "antd";
import { Content, Footer } from "antd/lib/layout/layout";
import { LoadingOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { AuthService } from "./AuthService";
import { useDispatch, useSelector } from "react-redux";
import { loginFailure, loginSuccess } from "../../Store/authStore";
import { setAccessToken } from "../../Store/apiStore";
import {
  AppStorageKeys,
  MessageKeys,
  PortalTitle,
} from "../../Constants/Constants";
import SessionStorage from "../../Constants/SessionStorage";

const ENV_VARS_FE = SessionStorage.get(AppStorageKeys.envVars);
const CLIENT_ID = ENV_VARS_FE.CLIENT_ID;
const { Header } = Layout;

export const LoginPage = (props) => {
  const dispatch = useDispatch();
  const [isLogging, setIsLogging] = useState(false);
  console.log("LoginPage props", props);

  const currentUser = useSelector((state) => state.auth.currentUser);

  useEffect(() => {
    message.destroy(MessageKeys.apiError);
    if (currentUser) {
      console.log("LoginPage logged in...");
      props.history.push("/");
    }
  }, [currentUser]);

  const getUserRoles = (accessToken) => {
    const decoded = jwt_decode(accessToken);
    return decoded?.resource_access[CLIENT_ID]?.roles;
  };

  const onLogin = async (values) => {
    if (isLogging) return;
    setIsLogging(true);
    const { username, password, remember } = values;
    const { protocol, hostname } = window.location;
    const authUrl = protocol + "//" + hostname;
    try {
      const loginRes = await AuthService.login(authUrl, username, password);
      console.log("loginRes:", loginRes);
      if (loginRes.code === 200) {
        message.success(`Welcome ${username}!`);
        const userInfo = loginRes.message;
        const roles = getUserRoles(userInfo?.access_token);
        userInfo.roles = roles || [];
        userInfo.username = username;
        console.log("Login success:", userInfo);
        dispatch(loginSuccess({ userInfo, remember }));
        dispatch(setAccessToken(userInfo.access_token));
      } else {
        message.error("Login failed: " + loginRes.message);
        dispatch(loginFailure());
      }
    } catch (error) {
      console.log("Login error:", error);
      message.error("Error authenticating user. Please try again.");
      dispatch(loginFailure());
    }
    setIsLogging(false);
  };

  return (
    <Layout className="login-page-container">
      <Header className="header">
        <div className="logo" />
        <div className="header-title">{PortalTitle}</div>
      </Header>
      <Content className="login-content">
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: false,
          }}
          onFinish={onLogin}
          requiredMark={false}
          labelCol={{ span: 7 }}
        >
          <div className="login-form-items-container">
            <Form.Item
              name="username"
              label="Username"
              rules={[
                {
                  required: true,
                  message: "Please enter username!",
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Username"
              />
            </Form.Item>
            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Please enter password!",
                },
              ]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                icon={isLogging && <LoadingOutlined />}
              >
                {isLogging ? "Logging in..." : "Log in"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        ©2021 CommScope Inc. All rights reserved.
      </Footer>
    </Layout>
  );
};
